import { Message } from 'element-ui'
import router from '@/router'
import store from '@/store'

const IDLE_TIMEOUT = 30 * 60 * 1000
const ACTIVITY_WRITE_INTERVAL = 1000
const LAST_ACTIVE_KEY = 'crm:lastActiveTime'
const LOGOUT_EVENT_KEY = 'crm:idleLogoutTime'
const ACTIVITY_EVENTS = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart']

let started = false
let timer = null
let loggingOut = false
let lastActivityWriteTime = 0

function now() {
  return new Date().getTime()
}

function getLastActiveTime() {
  const value = Number(window.localStorage.getItem(LAST_ACTIVE_KEY))
  return value > 0 ? value : now()
}

function clearTimer() {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
}

function scheduleCheck() {
  if (!started || loggingOut) {
    return
  }

  clearTimer()

  const elapsed = now() - getLastActiveTime()
  const remaining = IDLE_TIMEOUT - elapsed

  if (remaining <= 0) {
    idleLogout(true)
    return
  }

  timer = setTimeout(scheduleCheck, remaining)
}

function markActive(force) {
  if (!started || loggingOut) {
    return
  }

  const current = now()
  if (!force && current - lastActivityWriteTime < ACTIVITY_WRITE_INTERVAL) {
    return
  }

  lastActivityWriteTime = current
  window.localStorage.setItem(LAST_ACTIVE_KEY, String(current))
  scheduleCheck()
}

function handleActivity() {
  markActive(false)
}

function handleStorage(event) {
  if (event.key === LAST_ACTIVE_KEY) {
    scheduleCheck()
  }

  if (event.key === LOGOUT_EVENT_KEY && event.newValue) {
    idleLogout(false)
  }
}

function addListeners() {
  ACTIVITY_EVENTS.forEach(eventName => {
    window.addEventListener(eventName, handleActivity, true)
  })
  window.addEventListener('storage', handleStorage)
}

function removeListeners() {
  ACTIVITY_EVENTS.forEach(eventName => {
    window.removeEventListener(eventName, handleActivity, true)
  })
  window.removeEventListener('storage', handleStorage)
}

async function idleLogout(notifyOtherTabs) {
  if (loggingOut) {
    return
  }

  loggingOut = true
  clearTimer()
  removeListeners()

  if (notifyOtherTabs) {
    window.localStorage.setItem(LOGOUT_EVENT_KEY, String(now()))
  }

  if (router.currentRoute.path !== '/login') {
    Message.warning('Session timed out, please login again.')
  }

  try {
    await store.dispatch('user/logout', { request: notifyOtherTabs })
  } catch (e) {
    // Ignore logout request errors; the user still needs to return to login.
  }

  if (router.currentRoute.path !== '/login') {
    router.replace('/login')
  }

  started = false
  loggingOut = false
}

export function startIdleLogout(path) {
  if (path === '/login') {
    stopIdleLogout()
    return
  }

  if (!started) {
    started = true
    loggingOut = false
    addListeners()
  }

  markActive(true)
}

export function stopIdleLogout() {
  if (!started) {
    return
  }

  started = false
  loggingOut = false
  clearTimer()
  removeListeners()
}
